import { axios } from "../config";

function addTeacher(data) {
  return axios.post("api/v1/teachers", data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function fetchTeacherList(data) {
  return axios.get("api/v1/teachers", {
    params: data,
  });
}

function getAcademicDepartments() {
  return axios.get("api/v1/departments/stats");
}
function getTeacherStats() {
  return axios.get("api/v1/teachers/overview");
}
function getNonAcademicData() {
  return axios.get("api/v1/teachers/non-academic-view");
}

function getTeachersList(data) {
  return axios.post(`api/v1/teachers/get-teachers`, data);
}

function fetchTeacherDetails(id) {
  return axios.get(`api/v1/teachers/${id}`);
}

function deleteTeacher(id) {
  return axios.delete(`api/v1/teachers/${id}`);
}
function resendCredentialsTeachers(data) {
  return axios.post("api/v1/teachers/send-sms", data);
}

function bulkUploadTeacher(formData) {
  return axios.post(`/api/v1/teachers/bulk-upload`, formData, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function updateTeacher(id, data) {
  return axios.put(`api/v1/teachers/${id}`, data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function fetchTeacherAttendance(id) {
  return axios.get(`api/v1/teachers/attendance?teacher_id=${id}`);
}

function fetchTeacherWeeklyClasses(id) {
  return axios.get(`api/v1/teachers/get-weekly-teacher-class?teacher_id=${id}`);
}

function suspendTeacher(data) {
  return axios.post("api/v1/teachers/suspend", data);
}

function getTeacherAttendanceForExport(teacherID) {
  return axios.get(
    `api/v1/teachers/export-attendance?teacher_id=${teacherID}`,
    { responseType: "blob" }
  );
}

function getTeacherWeeklyClassesForExport(teacherID) {
  return axios.get(
    `api/v1/teachers/get-weekly-teacher-class?teacher_id=${teacherID}`,
    { responseType: "blob" }
  );
}

function getSubjectWiseTeachers() {
  return axios.get("api/v1/teachers/subjects/teachers");
}
function getTeacherAttendanceDetails(params) {
  return axios.get("api/v1/attendence/teachers", { params });
}
function getTeacherStatAttendance(params) {
  return axios.get("api/v1/attendence/teachers/stats", { params });
}
function getDeptById(id) {
  return axios.get(`api/v1/attendence/teachers?department_id=${id}`);
}
export {
  getDeptById,
  getTeacherStatAttendance,
  getTeacherAttendanceDetails,
  resendCredentialsTeachers,
  addTeacher,
  getAcademicDepartments,
  getTeacherStats,
  getNonAcademicData,
  fetchTeacherList,
  getTeachersList,
  fetchTeacherDetails,
  updateTeacher,
  deleteTeacher,
  fetchTeacherAttendance,
  fetchTeacherWeeklyClasses,
  suspendTeacher,
  bulkUploadTeacher,
  getTeacherAttendanceForExport,
  getTeacherWeeklyClassesForExport,
  getSubjectWiseTeachers,
};
